export default __webpack_public_path__ + "static/media/ee.eccfff94.svg";